import script from "./AppUpdatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUpdatePage.vue?vue&type=script&setup=true&lang=js"

import "./AppUpdatePage.vue?vue&type=style&index=0&id=058cfa82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058cfa82"]])

export default __exports__